import SectionShop from './SectionShop';

export default SectionShop;